<script>
	let entered = false;
	let q1, q2, q3;
	const checkAnswers = () => {
		if (q1 === "dutch" && q2 === "Bathroom" && q3 === "Christopher") {
		// if (true) {
			alert("you may pass...");
			entered = true;
		} else {
			alert(
				`HOLD ON, seems like you've got something wrong there. are you sure you answered correctly?`
			);
		}
	};
</script>

<main>
	{#if !entered}
		<div
			style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:100vh;"
		>
			<img
				alt=""
				src="/images/library.jpg"
				style="width:unset;height:100%;object-fit:contain"
			/>
			<div style="width:66.66%;padding:40px;">
				<h1>HAPPY BIRTHDAY ALEXANDRIA AITKEN!!!</h1>
				<h2>
					To enter the Library of Alexandria, please answer the
					following questions to verify your identity:
				</h2>
				<h3>1. What is your favorite genre of artwork?</h3>
				<select name="q1" id="q1" bind:value={q1}>
					<option value="">Select an answer</option>
					<option value="impressionism">Impressionism</option>
					<option value="dutch">Dutch and Flemish Renaissance</option>
					<option value="abstract">Abstract</option>
					<option value="Pre-Raphaelite">Pre-Raphaelite</option>
					<option value="Romanesque">Romanesque</option>
				</select>
				<h3>2. What is your favorite room in the house?</h3>
				<select name="q1" id="q1" bind:value={q2}>
					<option value="">Select an answer</option>
					<option value="Living Room">Living Room</option>
					<option value="Kitchen">Kitchen</option>
					<option value="Bathroom">Bathroom</option>
				</select>
				<h3>3. Who is your eternal lover?</h3>
				<select name="q1" id="q1" bind:value={q3}>
					<option value="">Select an answer</option>
					<option value="Christmas">Christmas</option>
					<option value="Christopher">Christopher</option>
				</select>
				<p />
				<button
					on:click={() => {
						checkAnswers();
					}}>attempt to enter</button
				>
			</div>
		</div>
	{:else}
		<div id="collage">
			<figure>
				<img alt="" src="/images/baby.jpg" />
				<figcaption>ah yes, the moment of birth</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/bayfront1.jpg" />
				<figcaption>led to this beautiful young lady</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/bayfront2.jpg" />
				<figcaption>who gave birth to our son</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple1.jpg" />
				<figcaption>we found each other</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple2.jpg" />
				<figcaption>and have been inseperable since</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple3fix.jpg" />
				<figcaption>like fraternal twins who've found each other again</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple4.jpg" />
				<figcaption>sometimes we tongue</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple5fix.jpg" />
				<figcaption>and sometimes you hide behind me</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple6fix.jpg" />
				<figcaption>and lock your arms around my shoulder</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple7fix.jpg" />
				<figcaption>and pucker your lips</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple8.jpg" />
				<figcaption>leaning on my left shoulder</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple9.jpg" />
				<figcaption>and leaning on my right</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple10.jpg" />
				<figcaption>i fucking love when our lips collide</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple11.jpg" />
				<figcaption>like magnetic poles finding their gravity</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple12.jpg" />
				<figcaption>spinning in an orbit</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple13.jpg" />
				<figcaption>ocassionally splitting (the horizon event)</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple14.jpg" />
				<figcaption>red light washes over us</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/couple15.jpg" />
				<figcaption>capturing nameless restaurants</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/flower.jpg" />
				<figcaption>finding beauty in and with each other</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting1.jpg" />
				<figcaption>oh yes, looks like we've finally reached the gallery</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting2.jpg" />
				<figcaption>dutch still life</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting3.jpg" />
				<figcaption>which has inspired many</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting4.jpg" />
				<figcaption>the dutch weren't completely classist</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting5.jpg" />
				<figcaption>butchtered animals</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting6.jpg" />
				<figcaption>fashionable</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting7.jpg" />
				<figcaption>alexandria in feline form</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting8.jpg" />
				<figcaption>elegant portraits</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting9.jpg" />
				<figcaption>some with thinning hair</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting10.jpg" />
				<figcaption>you do like observing history, don't you?</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting11.jpg" />
				<figcaption>reflections of a bygone era</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting12.jpg" />
				<figcaption>peering from their frames</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting13.jpg" />
				<figcaption>into your soul</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting14.jpg" />
				<figcaption>i wonder what they see</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting15.jpg" />
				<figcaption>i hope they're not disappointed</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting16.jpg" />
				<figcaption>we still have reverence</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting17.jpg" />
				<figcaption>for nature and beauty</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting18.jpg" />
				<figcaption>and we atone on a near-daily basis</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting19.jpg" />
				<figcaption>until the next hand is dealt</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting20.jpg" />
				<figcaption>if only, if only</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting21.jpg" />
				<figcaption>christmas could serve us like these medieval children would serve their parents</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting22.jpg" />
				<figcaption>we pray</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting23.jpg" />
				<figcaption>the original headband</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting24.jpg" />
				<figcaption>which many have taken from</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting25.jpg" />
				<figcaption>that beautiful green background</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting26.jpg" />
				<figcaption>did they even know?</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting27.jpg" />
				<figcaption>more glorious painting</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting28.jpg" />
				<figcaption>christmas' great great great grandparents</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting29.jpg" />
				<figcaption>hunting for game</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting30.jpg" />
				<figcaption>and serving eyes... on a platter</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting31.jpg" />
				<figcaption>still, we longed to return to our coast</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/painting32.jpg" />
				<figcaption>and we did</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/shadow.jpg" />
				<figcaption>spontaneous shadows</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/sign.jpg" />
				<figcaption>gem from our journey</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/young1.jpg" />
				<figcaption>cutie.</figcaption>
			</figure>
			<figure>
				<img alt="" src="/images/young2.jpg" />
				<figcaption>pie.</figcaption>
			</figure>
		</div>
		<div id="letter">
			<p>{`dear alexandria aitken,`}</p>

			<p>
				{`this card is dedicated to the 25th anniversary of your glorious day of birth- march 29th, 1997. a day which would forever change the world as we know it. through crazy and seemingly chaotic circumstance, you came onto this earth, and i cannot thank god enough that you did. you are so thoroughly beautiful, inside and out. you have the most exquisite, volumptious body which i love grabbing, smacking, and laying claim to. i constantly get lost staring into your eyes and scanning over your gorgeous face. your personality is so bubbly, radiant, and full of pure unadulturated life.`}
			</p>

			<p>
				{`although we're both sick, i'm glad we're sick together, and we're able to nurture each other back to health.`}
			</p>

			<p>
				{`i'm so fucking happy to have you in my life, and i can't wait to celebrate a minimum of 100 more birthdays together.`}
			</p>

			<p>
				{`with all my love,`}<br />
				{`your husband, christopher`}
			</p>
		</div>
		<button
			on:click={() => {
				entered = false;
			}}>leave the library</button
		>
	{/if}
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		margin: 0px;
	}

	h1 {
		color: #d100ff;
		font-size: 36px;
		margin: 0;
	}
	figure {
		display: inline-block;
		max-width: 300px;
	}
	img {
		width: 300px;
		height: 400px;
		object-fit: cover;
		margin: -3px;
	}
	button {
		margin: 20px;
		padding: 10px 20px;
	}
	select {
		width: 300px;
		padding: 10px 20px;
	}
	#letter {
		text-align: left;
		padding: 40px;
		line-height: 1.5;
	}
</style>
